import type { UniformConfigurationItem } from "types/uniformConfigurationItem";
import type { UniformFormColors } from "types/uniformFormColors";
import type { UniformFormType } from "types/uniformFormType";
import type { UniformItem } from "types/uniformItem";

export const transformUniformItemsResponse = (
  uniformItemTypes: UniformConfigurationItem[],
  uniformItemsResponse?: UniformItem[]
): UniformFormType["uniformParts"] =>
  uniformItemTypes
    .flatMap((x) => x.itemTypes)
    .reduce<UniformFormType["uniformParts"]>((acc, item) => {
      Object.entries(item).forEach((entry) => {
        const [itemType, colors] = entry;
        const responseItem = uniformItemsResponse?.find((x) => x.itemType === itemType);
        acc[itemType] = {
          uniformItemId: responseItem?.uniformItemId ?? "",
          nameLatin: responseItem?.nameLatin ?? "",
          nameLocal: responseItem?.nameLocal ?? "",
          colors: colors.reduce<UniformFormColors>((acc, color) => {
            acc[color] = responseItem?.colors[color];
            return acc;
          }, {}),
        };
      });
      return acc;
    }, {});
